import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72f7f516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-logo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "lead-logo",
    href: "/top"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://www.asking.co.jp/images/common/logo.png",
      alt: "株式会社アスキング"
    })
  ])
], -1))
const _hoisted_4 = { class: "header-nav" }
const _hoisted_5 = { class: "header-menu" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = { class: "icon-inner" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("nav", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "menu-item"
            }, [
              _createVNode(_component_router_link, {
                to: item.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", { src: _ctx.icon }, null, 8, _hoisted_8)
          ])
        ])
      ])
    ])
  ]))
}